import Weather from './Component/weather';
import './App.css'
function App() {
  return (
      <div>
        <header>
          <h1>Howz Weather</h1>
        </header>
        <Weather />
      </div>

      
  );
}

export default App;
